import Icon from '@mdi/react';
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogTrigger,
  Spinner,
} from '@purinanbm/pds-ui';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { mdiPurinaFilter } from 'src/assets/icons/mdiIcons';
import { getActiveFacets } from 'src/utils/helpers';
import SearchActiveFacetList from './SearchActiveFacetList';
import SearchFacets from './SearchFacets';
import { SearchListingContext } from './SearchListingContext';

type Props = {
  onFacetChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

export const FacetDialog = ({ onFacetChange }: Props) => {
  const [open, setOpen] = React.useState(false);
  const context = useContext(SearchListingContext);
  const { t } = useTranslation();
  const { data, loaded } = context || {};
  const { pager, facets = {} } = data || {};
  const activeFacets = getActiveFacets(facets);

  return (
    <Dialog open={open} onOpenChange={setOpen} aria-describedby={t('Filter By')}>
      <DialogTrigger asChild>
        <Button
          buttonStyle="tonal"
          buttonColor="neutral"
          aria-label={t('Filter results')}
          className="pds-rounded-circle pds-border-thick pds-border-solid pds-border-transparent pds-p-3 pds-font-[0px]"
        >
          <Icon path={mdiPurinaFilter} className="pds-inline" size={0.85} />
        </Button>
      </DialogTrigger>
      <DialogContent className="pds-flex !pds-h-[100dvh] !pds-max-h-[100dvh] !pds-w-[100dvw] !pds-max-w-[100dvw] pds-flex-col !pds-rounded-none pds-p-0">
        <div className="pds-flex pds-flex-col pds-gap-4 pds-border-b pds-px-4 pds-py-5">
          <DialogTitle>{t('Filter By')}</DialogTitle>
          <div>
            <SearchActiveFacetList
              className="ms-0 ps-0"
              activeFacets={activeFacets}
              onFacetRemove={onFacetChange}
            />
          </div>
        </div>
        <div className="pds-flex-auto pds-overflow-y-scroll pds-px-4">
          {!loaded && (
            <div className="pds-mt-4 pds-text-center">
              {!loaded && <Spinner color="currentColor" size={2} />}
            </div>
          )}
          {loaded && facets && <SearchFacets onChange={onFacetChange} />}
        </div>
        <div className="pds-mt-auto">
          <Button
            buttonColor="neutral"
            buttonStyle="solid"
            onClick={() => setOpen(false)}
            className="pds-font-body-lg pds-w-full pds-rounded-none pds-font-normal"
          >
            {!loaded && <Spinner color="currentColor" />}
            {loaded && pager && t('View result', { count: pager.total_items })}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
